import jsSHA from 'jssha'

export const version = '2.1.15'
console.info(`cyb_data_model.js - version ${version}`)

function sha256hash(text) {
  let sha256 = new jsSHA('SHA-256', 'TEXT');
  sha256.update(text);
  return sha256.getHash('HEX');
}

export class io {

  STATUS_OK = 1;
  STATUS_NOT_FOUND = 2;
  STATUS_BAD_PASSWORD = 3;
  STATUS_ERROR = 4;

  constructor() {
    this.version = 1;
    this.session = null;
    this.user_account = null;
    this.user_name = null;
    this.worker = new Worker('/js/ws_worker.js',{type: "module"});
    this.worker.onmessage = this.worker_onmessage;
    this.worker.onerror = this.worker_onerror;
    this.transaction = 0;
  }

  static hash(password) {
    return sha256hash(password);
  }

  static make_channel_promise() {
    const channel = new MessageChannel();
    const promise = new Promise((res, rej) => {
      channel.port1.onmessage = ({data}) => {
        channel.port1.close();
        if (data.error) {
          rej(data.error);
        } else {
          res(data.result);
        }
      }
    });

    return [channel, promise]
  }

  worker_onmessage(e) {
    // alert('worker_onmessage: ' + e.data);
    switch (e.data) {
      case 'invalid session':
        // alert('sesion invalida');
        const user = localStorage.getItem('currentUser');
        if (user != null)
        {
          localStorage.setItem('currentUser', null);
        }
        // alert(window.location);
        window.location.replace(window
          .location.origin);
        break;
    }
  }

  worker_onerror(e) {
    let message = `worker_onerror: ${e.message}\n\nfile: ${e.filename}, line: ${e.lineno}`
    alert(message);
  }

  login(user, password) {
    const channel = new MessageChannel();
    const promise = new Promise((res, rej) => {
      channel.port1.onmessage = ({data}) => {
        channel.port1.close();
        if (data.error) {
          rej(data.error);
        } else {
          // console.info('io.login: ' + JSON.stringify(data.result));
          this.session = data.result.s;
          this.user_account = data.user_account;
          res(data.result);
        }
      }
    });

    let password_hash = io.hash(password);

    let message = `{"fn":"login", "v":${this.version}, "user_account":"${user}", "password_hash":"${password_hash}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  login_ex(user, password) {
    const channel = new MessageChannel();
    const promise = new Promise((res, rej) => {
      channel.port1.onmessage = ({data}) => {
        channel.port1.close();
        if (data.error) {
          rej(data.error);
        } else {
          // console.info('io.login_ex: ' + JSON.stringify(data.result));
          this.session = data.result.s;
          this.user_account = data.user_account;
          res(data.result);
        }
      }
    });

    let password_hash = io.hash(password);

    let message = `{"fn":"login_ex", "v":${this.version}, "user_account":"${user}", "password_hash":"${password_hash}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_session_from_token(token){
    const channel = new MessageChannel();
    const promise = new Promise((res, rej) => {
      channel.port1.onmessage = ({data}) => {
        channel.port1.close();
        if (data.error) {
          rej(data.error);
        } else {
          console.info('get_session_from_token(reply): ' + JSON.stringify(data.result));
          if ('s' in data.result && 'user_account' in data.result){
            this.session = data.result.s;
            this.user_account = data.user_account;
            res(data.result);
          }
          else {
            alert ('get_session_from_token error');
            res(data.result);
          }
        }
      }
    });

    let message = `{"fn":"get_session_from_token", "v":${this.version}, "s":"${this.session}", "token":"${token}" }`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  change_password(user_account, password, new_password) {
    const [channel, promise] = io.make_channel_promise();

    let password_hash = io.hash(password);
    let new_password_hash = io.hash(new_password);

    let message = `{"fn":"change_password", "v":${this.version}, "s":"${this.session}", "user_account":"${user_account}", "password_hash":"${password_hash}", "new_password_hash":"${new_password_hash}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_users() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_users", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_user(id) {
    const [channel, promise] = io.make_channel_promise();

    let user = {};
    user.id = id;

    let message = `{"fn":"get_user", "v":${this.version}, "s":"${this.session}", "user":${JSON.stringify(user)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  set_users_group(user_accounts, group)
  {
    const [channel, promise] = io.make_channel_promise();

    if (typeof (group) !== 'number' || Object.is(NaN, group))
    {
      alert('set_users_group: grupo debe ser numerico')
      return null
    }
    let message = `{"fn":"set_users_group", "v":${this.version}, "s":"${this.session}", "user_accounts":${JSON.stringify(user_accounts)}, "group_id":${group}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_user_by_account(user_account) {
    const [channel, promise] = io.make_channel_promise();

    let user = {};
    user.user_account = user_account;

    let message = `{"fn":"get_user_by_account", "v":${this.version}, "s":"${this.session}", "user":${JSON.stringify(user)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  create_account(user) {
    const [channel, promise] = io.make_channel_promise();

    user.status = 1
    user.password_hash = io.hash(user.password);
    if ('password' in user) {
      delete user.password;
    }

    let str_user = JSON.stringify(user)

    let message = `{"fn":"create_account", "v":${this.version}, "s":"${this.session}", "user": ${str_user}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  update_account(user) {
    const [channel, promise] = io.make_channel_promise();

    // TODO movido por juan
    // user.password_hash = io.hash(user.password);
    if ('password' in user) {
      user.password_hash = io.hash(user.password);
      delete user.password;
    }

    let message = `{"fn":"update_account", "v":${this.version}, "s":"${this.session}", "user": ${JSON.stringify(user)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_ciudades() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_ciudades", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_comunas() {
    // const channel = new MessageChannel();
    // const promise = new Promise((res, rej) => {
    //     channel.port1.onmessage = ({data}) => {
    //         channel.port1.close();
    //         if (data.error) {
    //             rej(data.error);
    //         } else {
    //             res(data.result);
    //         }
    //     }
    // });

    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_comunas", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_provincias() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_provincias", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_tipos() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_tipos", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_roles() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_roles", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_propiedades(incluir_eliminadas) {
    const [channel, promise] = io.make_channel_promise();

    let message = null;
    if (incluir_eliminadas){
      message = `{"fn":"get_propiedades", "v":${this.version}, "s":"${this.session}", "incluir_eliminadas":true}`;
    }
    else {
      message = `{"fn":"get_propiedades", "v":${this.version}, "s":"${this.session}"}`;
    }
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_propiedades_by_ejecutivo(user_id_ejecutivo) {
    const [channel, promise] = io.make_channel_promise();

    let user = {}
    user.id = user_id_ejecutivo;

    let message = `{"fn":"get_propiedades_by_ejecutivo", "v":${this.version}, "s":"${this.session}", "user": ${JSON.stringify(user)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_propiedad(id) {
    const [channel, promise] = io.make_channel_promise();

    let propiedad = {'id': id};
    let message = `{"fn":"get_propiedad", "v":${this.version}, "s":"${this.session}", "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_propiedad_by_rol(rol) {
    const [channel, promise] = io.make_channel_promise();

    let propiedad = {"rol": rol};
    let message = `{"fn":"get_propiedad", "v":${this.version}, "s":"${this.session}", "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_propiedad_by_direccion(direccion) {
    const [channel, promise] = io.make_channel_promise();

    let propiedad = {"direccion": direccion};
    let message = `{"fn":"get_propiedad", "v":${this.version}, "s":"${this.session}", "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  create_propiedad(propiedad) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"create_propiedad", "v":${this.version}, "s":"${this.session}", "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  update_propiedad(propiedad) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"update_propiedad", "v":${this.version}, "s":"${this.session}", "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  delete_propiedad(propiedad) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"delete_propiedad", "v":${this.version}, "s":"${this.session}", "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  transfer_propiedades_by_ejecutivo(users, l_propiedades) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"transfer_propiedades_by_ejecutivo", "v":${this.version}, "s":"${this.session}", "users": ${JSON.stringify(users)}, "propiedades": ${JSON.stringify(l_propiedades)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  create_persona(persona, propiedad) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"create_persona", "v":${this.version}, "s":"${this.session}", "persona": ${JSON.stringify(persona)}, "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  update_persona(persona) {
    const [channel, promise] = io.make_channel_promise();

    if ('telefonos' in persona) {
      delete persona.telefonos;
    }

    let message = `{"fn":"update_persona", "v":${this.version}, "s":"${this.session}", "persona": ${JSON.stringify(persona)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_persona(id) {
    const [channel, promise] = io.make_channel_promise();

    let persona = {};
    persona.id = id;

    let message = `{"fn":"get_persona", "v":${this.version}, "s":"${this.session}", "persona": ${JSON.stringify(persona)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  delete_persona(id) {
    const [channel, promise] = io.make_channel_promise();

    let persona = {};
    persona.id = id;

    let message = `{"fn":"delete_persona", "v":${this.version}, "s":"${this.session}", "persona": ${JSON.stringify(persona)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  create_tarea(tarea) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"create_tarea", "v":${this.version}, "s":"${this.session}", "tarea": ${JSON.stringify(tarea)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  update_tarea(tarea) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"update_tarea", "v":${this.version}, "s":"${this.session}", "tarea": ${JSON.stringify(tarea)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_tarea(id) {
    const [channel, promise] = io.make_channel_promise();

    let tarea = {};
    tarea.id = id;

    let message = `{"fn":"get_tarea", "v":${this.version}, "s":"${this.session}", "tarea": ${JSON.stringify(tarea)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_tareas(user_id) {
    const [channel, promise] = io.make_channel_promise();

    let user = {};
    user.id = user_id;

    let message = `{"fn":"get_tareas", "v":${this.version}, "s":"${this.session}", "user": ${JSON.stringify(user)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_tareas_propiedad(user_id, propiedad_id) {
    const [channel, promise] = io.make_channel_promise();

    let user = {};
    user.id = user_id;
    let propiedad = {}
    propiedad.id = propiedad_id;

    let message = `{"fn":"get_tareas_propiedad", "v":${this.version}, "s":"${this.session}", "user": ${JSON.stringify(user)}, "propiedad": ${JSON.stringify(propiedad)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  create_evento(evento) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"create_evento", "v":${this.version}, "s":"${this.session}", "evento": ${JSON.stringify(evento)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  update_evento(evento) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"update_evento", "v":${this.version}, "s":"${this.session}", "evento": ${JSON.stringify(evento)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  create_telefono(telefono) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"create_telefono", "v":${this.version}, "s":"${this.session}", "telefono": ${JSON.stringify(telefono)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  update_telefono(telefono) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"update_telefono", "v":${this.version}, "s":"${this.session}", "telefono": ${JSON.stringify(telefono)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  delete_telefono(telefono) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"delete_telefono", "v":${this.version}, "s":"${this.session}", "telefono": ${JSON.stringify(telefono)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_cargas() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_cargas", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_tipos_resultado() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_tipos_resultado", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_ejecutivos_from_propiedades() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_ejecutivos_from_propiedades", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_grupos() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_grupos", "v":${this.version}, "s":"${this.session}"}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  create_grupo(grupo) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"create_grupo", "v":${this.version}, "s":"${this.session}", "grupo": ${JSON.stringify(grupo)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  update_grupo(grupo) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"update_grupo", "v":${this.version}, "s":"${this.session}", "grupo": ${JSON.stringify(grupo)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  delete_grupo(grupo) {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"delete_grupo", "v":${this.version}, "s":"${this.session}", "grupo": ${JSON.stringify(grupo)}}`;
    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  get_stat(name, params=null) {
    const [channel, promise] = io.make_channel_promise();

    let stat = {name: name, params: params}
    let message = `{"fn":"get_stats", "v":${this.version}, "s":"${this.session}",  "stat": ${JSON.stringify(stat)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_carga_stats(carga_id = null, ejecutivo_id = null) {
    const [channel, promise] = io.make_channel_promise();

    let carga = {"id":carga_id}
    let ejecutivo = {"id":ejecutivo_id}

    let message = `{"fn":"get_carga_stats", "v":${this.version}, "s":"${this.session}",  "carga": ${JSON.stringify(carga)}, "ejecutivo": ${JSON.stringify(ejecutivo)} }`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_periodo_stats(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, grupo_id=null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let grupo = {"id": grupo_id}

    let message = `{"fn":"get_periodo_stats", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "grupo": ${JSON.stringify(grupo)} }`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  get_periodo_stats_pdf(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}

    let message = `{"fn":"get_periodo_stats_pdf", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)} }`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_periodo_stats_excel(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}

    let message = `{"fn":"get_periodo_stats_excel", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)} }`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_flujo_periodo_stats(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"get_flujo_periodo_stats", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  get_causales_eliminacion(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"get_causales_eliminacion_stats", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  export_propiedades(p_rangos = null, p_filtro_inclusivo = null, p_search = null, p_order=null, p_generar) {
    const [channel, promise] = io.make_channel_promise();

    let rangos = p_rangos
    let filtro_inclusivo = p_filtro_inclusivo
    let generar = p_generar
    let search = p_search
    let order = p_order


    let message = `{"fn":"export_propiedades", "v":${this.version}, "s":"${this.session}",  "rangos": ${JSON.stringify(rangos)}, "filtro_inclusivo": ${JSON.stringify(filtro_inclusivo)}, "search": ${JSON.stringify(search)}, "order": ${JSON.stringify(order)},  "generar": "${generar}"}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  get_flujo_periodo_stats_PDF(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"get_flujo_periodo_stats", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_flujo_periodo_stats_Excel(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"get_flujo_periodo_stats", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_causales_eliminacion_PDF(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"get_causales_eliminacion", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_causales_eliminacion_Excel(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"get_causales_eliminacion", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }


  export_data(fecha_inicial = null, fecha_final= null, tipo_periodo=null, ejecutivo_id = null, p_generar= null) {
    const [channel, promise] = io.make_channel_promise();

    let rango = {"fecha_inicial": fecha_inicial, "fecha_final": fecha_final}
    let ejecutivo = {"id": ejecutivo_id}
    let periodo = {"tipo": tipo_periodo}
    let generar = {"tipo": p_generar}

    let message = `{"fn":"export_data", "v":${this.version}, "s":"${this.session}",  "rango": ${JSON.stringify(rango)}, "periodo": ${JSON.stringify(periodo)}, "ejecutivo": ${JSON.stringify(ejecutivo)}, "generar": ${JSON.stringify(generar)}}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  pg_sleep(p_delay) {
    const [channel, promise] = io.make_channel_promise();

    let delay = p_delay
    let message = `{"fn":"postgres_pgsleep", "v":${this.version}, "s":"${this.session}", "delay": ${delay}  }`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  get_token() {
    const [channel, promise] = io.make_channel_promise();

    let message = `{"fn":"get_token", "v":${this.version}, "s":"${this.session}"}`;

    this.worker.postMessage(message, [channel.port2]);
    return promise;
  }

  send_file(p_file, action=null) {

    const [channel, promise] = io.make_channel_promise();

    let file = {};
    file.name = p_file.name;
    file.size = p_file.size;
    file.type = p_file.type;

    let this_worker = this.worker;
    let this_session = this.session;
    let this_version = this.version;

    let fr = new FileReader();

    fr.onload = function (e) {
      console.log('FileReader onload');
      let base64String = e.target.result;
      // console.log("FileReader e.target.result: " + file.contents);
      let message = `{"fn":"send_file", "v":${this_version}, "s":"${this_session}", "metadata": ${JSON.stringify(file)}, "action":${JSON.stringify(action)}, "contents": "${base64String}"}`;
      this_worker.postMessage(message, [channel.port2]);
    };

    fr.onerror = function (err) {
      console.error('FileReader error: ' + err)
    }

    fr.readAsDataURL(p_file);

    return promise;
  }
}

